<template>
  <!-- ====== 管理员禁用 ====== -->
  <el-dialog
    top="20vh"
    width="500px"
    center
    :title="
      adminDisableObj.group
        ? `系统群禁用 ${
            adminDisableObj.username ? adminDisableObj.username : ''
          }`
        : `系统禁用 ${adminDisableObj.username ? adminDisableObj.username : ''}`
    "
    :visible="adminDisableObj.visible"
    :close-on-click-modal="false"
    @close="HandleCancelAdminDisableDialog()"
  >
    <el-row>
      <el-col :span="24">
        <el-alert v-if="adminDisableObj.group" type="error" :closable="false">
          <span style="font-size: 22px">{{ adminDisableObj.username }}</span>
          之下的所有代理、卡主都禁用<br /><br />且由此禁用的用户仅能再由管理员开启！
        </el-alert>
        <el-alert v-else type="error" :closable="false">
          由此禁用的用户仅能再由管理员开启！
        </el-alert>
        <br />
      </el-col>
      <el-col :span="24">
        <el-input
          clearable
          :placeholder="
            adminDisableObj.group
              ? '此特殊说明无论本来用户是否已禁用过，特殊原因禁用都将直接覆盖...'
              : '特殊原因禁用...'
          "
          v-model="adminDisableObj.specialRemark"
        />
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="HandleCancelAdminDisableDialog()" size="small"
        >取消</el-button
      >
      <el-button
        @click="HandleSubmitAdminDisableDialog()"
        size="small"
        type="success"
        >提交
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { adminDisable, adminDisableAllLowerLevel } from "@/api/user";
export default {
  mixins: [mainCommon],
  props: ["adminDisableDialog"],
  watch: {
    adminDisableDialog: {
      handler: function (val) {
        if (val.id) {
          this.adminDisableObj = val;
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      adminDisableObj: {
        id: null,
        username: null,
        specialRemark: "",
        visible: false,
        group: false, // 群删除
      },
    };
  },
  methods: {
    HandleSubmitAdminDisableDialog() {
      if (this.adminDisableObj.group) {
        this.$confirm(
          `此为群禁用，请再次确认禁用 ${this.adminDisableObj.username} 之下所有卡主及代理，且仅能由管理员再开启`,
          `${this.adminDisableObj.username} 群禁用`,
          {
            confirmButtonText: varCommon.message.confirm,
            cancelButtonText: varCommon.message.cancel,
            type: "warning",
          }
        ).then(() => {
          adminDisableAllLowerLevel(this.adminDisableDialog.id, {
            specialRemark: this.adminDisableDialog.specialRemark,
          }).then((res) => {
            this.$notify.success(res.message);
            this.$emit("HandleGetList");
            this.HandleCancelAdminDisableDialog();
          });
        });
      } else {
        adminDisable(this.adminDisableDialog.id, {
          specialRemark: this.adminDisableDialog.specialRemark,
        }).then((res) => {
          this.$notify.success(res.message);
          this.$emit("HandleGetList");
          this.HandleCancelAdminDisableDialog();
        });
      }
    },
    HandleCancelAdminDisableDialog() {
      this.adminDisableObj = {
        id: null,
        username: null,
        specialRemark: "",
        visible: false,
        group: false, // 群删除
      };
      this.$emit("update:admin-disable-dialog", {
        id: null,
        username: null,
        specialRemark: "",
        visible: false,
        group: false, // 群删除
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/SystemDisableUser.vue